import axios from 'axios';
import { getApiBaseURL } from '../utils/backendUrl';

const apiClient = axios.create({
  baseURL: getApiBaseURL(),
  withCredentials: true,
});

export const checkAuthStatus = () => {
  // Цей ендпоінт ми створимо пізніше
  return apiClient.get('/auth/status');
};
export const testLogin = () => apiClient.post('/auth/test-login');

export const getTabs = () => apiClient.get('/tabs');
export const createTab = (tabData) => apiClient.post('/tabs', tabData);
export const updateTab = (id, tabData) => apiClient.put(`/tabs/${id}`, tabData);
export const deleteTab = (id) => apiClient.delete(`/tabs/${id}`);
export const deleteAllTabs = () => apiClient.delete('/tabs');

// Функції для роботи з user preferences
export const getUserPreferences = () => apiClient.get('/preferences');
export const updateUserPreferences = (preferences) => apiClient.put('/preferences', preferences);

// Функції для роботи з user profile
export const getProfile = () => apiClient.get('/profile');
export const updateProfile = (data) => apiClient.put('/profile', data);
export const updateProfilePhoto = (photoBase64) => apiClient.post('/profile/photo', { photo_base64: photoBase64 });

// Функції для роботи з валютами
export const getCurrencyRates = () => apiClient.get('/currency/rates');
export const convertUSDToUAH = (amount) => apiClient.get(`/currency/convert/usd-to-uah?amount=${amount}`);
export const convertEURToUAH = (amount) => apiClient.get(`/currency/convert/eur-to-uah?amount=${amount}`);

// Функції для роботи з pricing
export const getRegionalPricing = () => apiClient.get('/pricing/regions');
export const getPriceForRegion = (region, productId, quantity = 1) => 
  apiClient.get(`/pricing/regions/${region}?product_id=${productId}&quantity=${quantity}`);
export const calculateRegionalTotal = (region, products) => 
  apiClient.post(`/pricing/regions/${region}/calculate`, { products });

// Advanced pricing functions
export const calculateProductPrice = (productRequest) => 
  apiClient.post('/pricing/calculate', productRequest);
export const calculateComplexTotal = (regionProductsRequest) => 
  apiClient.post('/pricing/calculate-total', regionProductsRequest);
export const calculateBundlePrice = (bundleRequest) => 
  apiClient.post('/pricing/calculate-bundle', bundleRequest);

// Функції для роботи з оферами (захищені - тільки для створення)
export const createOffer = (offerData) => apiClient.post('/offers', offerData);
export const getMyOffers = (page = 1, limit = 50, dateFrom = '', dateTo = '') => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', limit);
  if (dateFrom) params.append('date_from', dateFrom);
  if (dateTo) params.append('date_to', dateTo);
  return apiClient.get(`/offers/my?${params.toString()}`);
};

// Функції для роботи з порівняннями (захищені - тільки для створення)
export const createComparison = (comparisonData) => {
  return apiClient.post('/comparisons', comparisonData);
};
export const getMyComparisons = (page = 1, limit = 50, dateFrom = '', dateTo = '') => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', limit);
  if (dateFrom) params.append('date_from', dateFrom);
  if (dateTo) params.append('date_to', dateTo);
  return apiClient.get(`/comparisons/my?${params.toString()}`);
};

// Функція для отримання комбінованої історії (офери + порівняння)
export const getMyHistory = (page = 1, limit = 50, dateFrom = '', dateTo = '', clientName = '') => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', limit);
  if (dateFrom) params.append('date_from', dateFrom);
  if (dateTo) params.append('date_to', dateTo);
  if (clientName) params.append('client_name', clientName);
  return apiClient.get(`/history?${params.toString()}`);
};

// Публічні функції для перегляду оферів та порівнянь (без автентифікації)
export const getOffer = (offerId) => apiClient.get(`/offers/${offerId}`);
export const getComparison = (comparisonId) => apiClient.get(`/comparisons/${comparisonId}`);

// Admin API functions
export const getAllUsers = (page = 1, limit = 20, search = '') => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', limit);
  if (search) params.append('search', search);
  return apiClient.get(`/admin/users?${params.toString()}`);
};

export const updateUserRole = (userId, role) =>
  apiClient.put(`/admin/users/${userId}/role`, { role });

export const getUserHistory = (userId, page = 1, limit = 50, dateFrom = '', dateTo = '', clientName = '') => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', limit);
  if (dateFrom) params.append('date_from', dateFrom);
  if (dateTo) params.append('date_to', dateTo);
  if (clientName) params.append('client_name', clientName);
  return apiClient.get(`/admin/users/${userId}/history?${params.toString()}`);
};

export default apiClient;
